"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthUIRegisterEmail = exports.AuthUIPassworReset = exports.AuthUIEmail = exports.AuthUISelector = exports.AuthUI = void 0;
const react_1 = __importDefault(require("react"));
const auth_1 = require("firebase/auth");
const firebase_app_1 = __importDefault(require("common/firebase-app"));
const schemaComponents_1 = require("@/schemaComponents");
const standard_1 = require("react-hook-schema/standard");
require("firebaseui/dist/firebaseui.css");
const react_router_1 = require("react-router");
const Selector_1 = require("./Selector");
const logo_icon_gray_svg_1 = __importDefault(require("../../../../assets/logo-icon-gray.svg"));
const auth_2 = require("common/auth");
const auth = (0, auth_1.getAuth)(firebase_app_1.default);
const wait = (time) => new Promise((resolve) => setTimeout(resolve, time));
const AuthUI = ({ provider }) => {
    const [uiState, setUiState] = react_1.default.useState("selector");
    const location = (0, react_router_1.useLocation)();
    const searchParams = new URLSearchParams(location.search);
    const oobCode = searchParams.get("oobCode");
    if (oobCode) {
        return react_1.default.createElement(exports.AuthUIPassworReset, { setUiState: setUiState });
    }
    else if (uiState === "email") {
        return react_1.default.createElement(exports.AuthUIEmail, { setUiState: setUiState });
    }
    else if (uiState === "registerEmail") {
        return react_1.default.createElement(exports.AuthUIRegisterEmail, { setUiState: setUiState });
    }
    else {
        return react_1.default.createElement(exports.AuthUISelector, { setUiState: setUiState, provider: provider });
    }
};
exports.AuthUI = AuthUI;
const AuthUISelector = ({ setUiState, provider, }) => {
    var _a, _b, _c;
    const toast = (0, standard_1.useToast)();
    const navigate = (0, react_router_1.useNavigate)();
    const configs = [
        {
            iconUrl: logo_icon_gray_svg_1.default,
            providerId: "oidc.drecom_dev",
            backgroundColor: "#ffffff",
            color: "#333",
            imageStyle: {
                transform: "scale(1.5)",
                transformOrigin: "center",
                position: "relative",
                left: "-5px",
            },
            fullLabel: "Continue with ai and",
            shortLabel: "aiand",
            handler: (0, auth_2.siAuthHandlerFactory)((_a = process.env.REACT_APP_SIGN_IN_WITH_DRECOM_FIREBASE_FUNCTION_ORIGIN) !== null && _a !== void 0 ? _a : "", (_b = process.env.REACT_APP_SIGN_IN_WITH_DRECOM_SIGN_IN_PAGE_URL) !== null && _b !== void 0 ? _b : "", (_c = process.env.REACT_APP_SIGN_IN_WITH_DRECOM_TARGET) !== null && _c !== void 0 ? _c : "", auth, toast),
        },
    ];
    switch (provider) {
        case "google":
            configs.push({
                iconUrl: "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg",
                providerId: "google.com",
                backgroundColor: "#ffffff",
                color: "#757575",
                fullLabel: "Continue with Google",
                shortLabel: "Google",
                handler: () => __awaiter(void 0, void 0, void 0, function* () {
                    try {
                        yield (0, auth_1.signInWithPopup)(auth, new auth_1.GoogleAuthProvider());
                    }
                    catch (e) {
                        toast({
                            message: (0, auth_2.formatErrorMessage)(e),
                            duration: 10000,
                        });
                    }
                }),
            });
            break;
        case "microsoft":
            configs.push({
                iconUrl: "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/microsoft.svg",
                providerId: "microsoft.com",
                backgroundColor: "#2F2F2F",
                fullLabel: "Continue with Microsoft",
                shortLabel: "Microsoft",
                handler: () => __awaiter(void 0, void 0, void 0, function* () {
                    try {
                        yield (0, auth_1.signInWithPopup)(auth, new auth_1.OAuthProvider("microsoft.com"));
                    }
                    catch (e) {
                        toast({
                            message: (0, auth_2.formatErrorMessage)(e),
                            duration: 10000,
                        });
                    }
                }),
            });
            break;
        case "email":
            configs.push({
                iconUrl: "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/mail.svg",
                providerId: "password",
                backgroundColor: "#db4437",
                fullLabel: "Sign in with email",
                shortLabel: "Email",
                handler: () => {
                    console.log("email");
                    setUiState("email");
                },
            });
            break;
    }
    return (react_1.default.createElement("section", { className: "hero adjust-width" },
        react_1.default.createElement("div", { className: "hero-body" },
            react_1.default.createElement("h1", { className: "title" }, "\u30ED\u30B0\u30A4\u30F3")),
        react_1.default.createElement("div", { id: "firebaseui_container", lang: "en" },
            react_1.default.createElement("div", { className: "firebaseui-container firebaseui-page-provider-sign-in firebaseui-id-page-provider-sign-in firebaseui-use-spinner" },
                react_1.default.createElement("div", { className: "firebaseui-card-content" },
                    react_1.default.createElement("ul", { className: "firebaseui-idp-list" },
                        react_1.default.createElement(Selector_1.AuthSelector, { configs: configs }))),
                react_1.default.createElement("div", { className: "firebaseui-card-footer firebaseui-provider-sign-in-footer" })))));
};
exports.AuthUISelector = AuthUISelector;
const AuthUIEmail = ({ setUiState, }) => {
    const toast = (0, standard_1.useToast)();
    return (react_1.default.createElement("section", { className: "hero adjust-width" },
        react_1.default.createElement("div", { className: "hero-body" },
            react_1.default.createElement("h1", { className: "title" }, "\u30ED\u30B0\u30A4\u30F3")),
        react_1.default.createElement("div", { id: "firebaseui_container", lang: "en" },
            react_1.default.createElement("div", { className: "firebaseui-container firebaseui-page-provider-sign-in firebaseui-id-page-provider-sign-in firebaseui-use-spinner" },
                react_1.default.createElement("div", { className: "firebaseui-card-content" },
                    react_1.default.createElement(schemaComponents_1.SchemaForm, { data: {}, parameter: {
                            title: "ログイン",
                            schema: {
                                schemaType: "object",
                                properties: [
                                    {
                                        propertyName: "email",
                                        title: "メールアドレス",
                                        schema: { schemaType: "email", required: true },
                                    },
                                    {
                                        propertyName: "password",
                                        title: "パスワード",
                                        schema: {
                                            schemaType: "password",
                                            minLength: 6,
                                            required: true,
                                        },
                                    },
                                ],
                            },
                            edit: {
                                title: "ログイン",
                                handler: (value) => __awaiter(void 0, void 0, void 0, function* () {
                                    try {
                                        yield (0, auth_1.signInWithEmailAndPassword)(auth, value.email, value.password);
                                    }
                                    catch (e) {
                                        toast({
                                            message: (0, auth_2.formatErrorMessage)(e),
                                            duration: 10000,
                                        });
                                    }
                                }),
                                confirm: false,
                            },
                            back: {
                                title: "キャンセル",
                                handler: () => __awaiter(void 0, void 0, void 0, function* () {
                                    setUiState("selector");
                                }),
                            },
                        } })),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("a", { onClick: () => setUiState("registerEmail"), href: "#" }, "\u65B0\u898F\u5229\u7528\u958B\u59CB\u30FB\u30D1\u30B9\u30EF\u30FC\u30C9\u518D\u8A2D\u5B9A\u306F\u3053\u3061\u3089")),
                react_1.default.createElement("div", { className: "firebaseui-card-footer firebaseui-provider-sign-in-footer" })))));
};
exports.AuthUIEmail = AuthUIEmail;
const AuthUIPassworReset = ({ setUiState, }) => {
    const toast = (0, standard_1.useToast)();
    const navigate = (0, react_router_1.useNavigate)();
    return (react_1.default.createElement("section", { className: "hero adjust-width" },
        react_1.default.createElement("div", { className: "hero-body" },
            react_1.default.createElement("h1", { className: "title" }, "\u30D1\u30B9\u30EF\u30FC\u30C9\u8A2D\u5B9A")),
        react_1.default.createElement("div", { id: "firebaseui_container", lang: "en" },
            react_1.default.createElement("div", { className: "firebaseui-container firebaseui-page-provider-sign-in firebaseui-id-page-provider-sign-in firebaseui-use-spinner" },
                react_1.default.createElement("div", { className: "firebaseui-card-content" },
                    react_1.default.createElement(schemaComponents_1.SchemaForm, { data: {}, parameter: {
                            title: "",
                            schema: {
                                schemaType: "object",
                                properties: [
                                    {
                                        propertyName: "email",
                                        title: "メールアドレス（確認）",
                                        tooltip: "メールを送信したアドレスと同じアドレスを指定してください。",
                                        schema: { schemaType: "email", required: true },
                                    },
                                    {
                                        propertyName: "password",
                                        title: "新しいパスワード",
                                        tooltip: "新しい6文字以上のパスワードを指定してください。",
                                        schema: {
                                            schemaType: "password",
                                            required: true,
                                            minLength: 6,
                                        },
                                    },
                                ],
                            },
                            edit: {
                                title: "設定",
                                handler: (value) => __awaiter(void 0, void 0, void 0, function* () {
                                    const initialPath = location.pathname + location.search;
                                    try {
                                        const userCredential = yield (0, auth_1.signInWithEmailLink)(auth, value.email, location.href);
                                        try {
                                            yield (0, auth_1.updatePassword)(userCredential.user, value.password);
                                        }
                                        catch (e) {
                                            yield (0, auth_1.signOut)(auth);
                                            yield wait(100);
                                            navigate(initialPath);
                                            throw e;
                                        }
                                    }
                                    catch (e) {
                                        toast({
                                            message: (0, auth_2.formatErrorMessage)(e),
                                            duration: 10000,
                                        });
                                    }
                                }),
                                confirm: false,
                            },
                            back: {
                                title: "キャンセル",
                                handler: () => __awaiter(void 0, void 0, void 0, function* () {
                                    setUiState("selector");
                                    navigate(location.pathname);
                                }),
                            },
                        } })),
                react_1.default.createElement("div", { className: "firebaseui-card-footer firebaseui-provider-sign-in-footer" })))));
};
exports.AuthUIPassworReset = AuthUIPassworReset;
const AuthUIRegisterEmail = ({ setUiState, }) => {
    const toast = (0, standard_1.useToast)();
    const [completed, setCompleted] = react_1.default.useState(false);
    return (react_1.default.createElement("section", { className: "hero adjust-width" },
        react_1.default.createElement("div", { className: "hero-body" },
            react_1.default.createElement("h1", { className: "title" }, "\u65B0\u898F\u767B\u9332")),
        react_1.default.createElement("div", { id: "firebaseui_container", lang: "en" },
            react_1.default.createElement("div", { className: "firebaseui-container firebaseui-page-provider-sign-in firebaseui-id-page-provider-sign-in firebaseui-use-spinner" },
                completed && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: "firebaseui-card-content" },
                        react_1.default.createElement("p", null, "\u30E1\u30FC\u30EB\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F\u3002\u30E1\u30FC\u30EB\u306E\u30EA\u30F3\u30AF\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u767B\u9332\u3092\u5B8C\u4E86\u3057\u3066\u304F\u3060\u3055\u3044\u3002")),
                    react_1.default.createElement("p", { style: { paddingBlock: "15px" } },
                        react_1.default.createElement("a", { onClick: () => setUiState("selector"), href: "#" }, "\u6700\u521D\u306B\u623B\u308B")))),
                !completed && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: "firebaseui-card-content" },
                        react_1.default.createElement(schemaComponents_1.SchemaForm, { data: {}, parameter: {
                                title: "",
                                schema: {
                                    schemaType: "object",
                                    properties: [
                                        {
                                            propertyName: "email",
                                            title: "メールアドレス",
                                            schema: { schemaType: "email", required: true },
                                        },
                                    ],
                                },
                                edit: {
                                    title: "送信",
                                    handler: (value) => __awaiter(void 0, void 0, void 0, function* () {
                                        try {
                                            yield (0, auth_1.sendSignInLinkToEmail)(auth, value.email, {
                                                url: window.location.href,
                                                handleCodeInApp: true,
                                            });
                                            setCompleted(true);
                                        }
                                        catch (e) {
                                            toast({
                                                message: (0, auth_2.formatErrorMessage)(e),
                                                duration: 10000,
                                            });
                                        }
                                    }),
                                    confirm: false,
                                },
                                back: {
                                    title: "キャンセル",
                                    handler: () => __awaiter(void 0, void 0, void 0, function* () {
                                        setUiState("selector");
                                    }),
                                },
                            } })),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement("a", { onClick: () => setUiState("email"), href: "#" }, "\u30ED\u30B0\u30A4\u30F3\u306F\u3053\u3061\u3089"))))),
            react_1.default.createElement("div", { className: "firebaseui-card-footer firebaseui-provider-sign-in-footer" }))));
};
exports.AuthUIRegisterEmail = AuthUIRegisterEmail;
